module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "category__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm._l((_vm.$store.getters.categories[_vm.categIndex(_vm.title)]), function(animal, i) {
    return _c('div', {
      key: ("" + animal + i),
      staticClass: "col-12 col-md-6 col-lg-4"
    }, [_c('card', {
      attrs: {
        "img": animal.img,
        "species": animal.species,
        "about": animal.about,
        "wikiLink": animal.wikiLink
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8e7a4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
// module id = 25
// module chunks = 0